import {Component, Inject, Input, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {
  EVENT_CALENDAR_ROUTE,
  EVENT_DETAILS
} from "src/app/app-routing.module";
import {environment} from "@environment";
import {AbstractComponent} from "@components";
import {
  EventItem, Lookups
} from "@model";
import {SwiperComponent} from "swiper/angular";
import {Subject} from "rxjs";
import {isPlatformBrowser} from "@angular/common";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  animations: [
    trigger('fadeIn', [
      state('hidden', style({
        opacity: 0
      })),
      state('visible', style({
        opacity: 1
      })),
      transition('hidden => visible', [
        animate('0.3s ease-in')
      ])
    ])
  ],
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent extends AbstractComponent implements OnInit {

  @Input() isLanding: boolean = false;
  @ViewChild('upcomingEventsSwiper', {static: false}) upcomingEventsSwiper?: SwiperComponent;
  @ViewChild('newEventsSwiper', {static: false}) newEventsSwiper?: SwiperComponent;
  @ViewChild('newSportSwiper', {static: false}) newSportSwiper?: SwiperComponent;

  @Input() upcomingItems: EventItem[] = [];
  @Input() newItems: EventItem[] = [];
  @Input() countries: Lookups[] = [];
  @Input({required: true}) languages: Lookups[] = [];

  searchQuery = new Subject();
  page: number = 1;
  environment: any = environment;
  breakpoints = {
    1400: {slidesPerView: 3, spaceBetween: 0},
    992: {slidesPerView: 3, spaceBetween: 0},
    576: {slidesPerView: 2, spaceBetween: 0},
    320: {slidesPerView: 1, spaceBetween: 0}
  };

  sports = [
    {
      id: 34,
      imgSrc: 'assets/icons/running.svg',
      buttonTextKey: 'app.common.sports.34',
      buttonClass: 'rounded-button--white-solid'
    },
    {
      id: 39,
      imgSrc: 'assets/icons/trail_running.svg',
      buttonTextKey: 'app.common.sports.39',
      buttonClass: 'rounded-button--white-solid'
    },
    {
      id: 40,
      imgSrc: 'assets/icons/triathlon.svg',
      buttonTextKey: 'app.common.sports.40',
      buttonClass: 'rounded-button--white-solid'
    },
    {
      id: 8,
      imgSrc: 'assets/icons/swimming.svg',
      buttonTextKey: 'app.common.sports.8',
      buttonClass: 'rounded-button--white-solid'
    },
    {id: undefined, imgSrc: '', buttonTextKey: 'app.common.sports.43', buttonClass: 'rounded-button--landing-other'}
  ];
  isBrowser: boolean;
  fadeState = 'hidden';

  constructor(private router: Router, private route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object) {
    super();

    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      setTimeout(() => {
        this.fadeState = 'visible';
      }, 300);
    }
  }

  goToEventDetailsPage(item: EventItem) {
    this.router.navigate([EVENT_DETAILS], {
      relativeTo: this.route,
      queryParams: {eventId: item.id}
    });
  }

  trackByFn(index: number, item: EventItem) {
    return item.id;
  }

  exploreAll() {
    this.router.navigate([EVENT_CALENDAR_ROUTE]);
  }

  slideNext(swiperComponent: SwiperComponent | undefined) {
    if (!swiperComponent || this.isLastSlideActive(swiperComponent)) return;
    swiperComponent.swiperRef.slideNext(300);
  }

  slidePrev(swiperComponent: SwiperComponent | undefined) {
    if (!swiperComponent || this.isFirstSlideActive(swiperComponent)) return;
    swiperComponent.swiperRef.slidePrev(300);
  }

  isLastSlideActive(swiper?: SwiperComponent): boolean {
    if (!swiper || !swiper.swiperRef) return false;
    return swiper.swiperRef.activeIndex === (swiper.swiperRef.slides.length - 3);
  }

  isFirstSlideActive(swiper?: SwiperComponent): boolean {
    if (!swiper || !swiper.swiperRef) return true;
    return swiper.swiperRef.activeIndex === 0;
  }

  explore(sportId?: number) {
    const queryParams = sportId ? {sportId} : {};
    this.router.navigate([EVENT_CALENDAR_ROUTE], {queryParams});
  }
}
